export default __webpack_public_path__ + "static/media/dai.664df0db.svg";